export default __webpack_public_path__ + "static/media/ic_gmx_footer.ff878c31.svg";